export default ({ app, redirect, route, store }) => {
  if (process.env.MAINTENANCE_MODE === 'true' || store.getters['maintenance/enabled']) {
    return redirect(app.localePath({ name: 'maintenance' }) + '/')
  }

  if ((process.env.MAINTENANCE_MODE === 'false' || store.getters['maintenance/disabled']) && route.name === 'maintenance___' + app.i18n.locale) {
    return redirect('/')
  }
}
